<!--
@负责人: zhijie.huang
@创建时间: 2018-11-08
@版本: v2.0.0
@描述: 图表，带头部和操作按钮，集成 chart-base
@使用方法:
<template>
  <chart-config :ref="item.chartId" :chart-index="index" :chart-id="item.chartId" :title="item.title" :chart-data="item.chartData"></chart-config>
</template>
<script>
    
</script>
@参数说明:
继承chart-base的属性
// 图表id
// chartId
// 图表数据，一般配合chartBiz得到合适的数据
// chartData = {
  // 数据
  rows: [],
  // 维度+指标1+指标2...
  columns: ['eventTime', 'value'],
  // 指标的文本
  labelMap: {
    eventTime: '时间',
    value: '数值'
  },
  // 数据格式化 默认NUMBER 'PERCENT','NUMBER','SIZE','TIME','BKM'
  formatMap: {
    eventTime: 'TIME'
  }
}
// 图表option
// chartStyle
// 是否黑色主题
// darkTheme

// 增加的属性
// 标题文本
title
// 是否有右侧按钮
clickable
// 右侧按钮回调
clickFun
// icon相关
icon: {
  label: 文字
  classname: class名
}
-->
<style>
.chart-config {
  position: relative;
  border: 1px solid #F0F0F0;
}
.chart-config__alarm {
  background: #F56C6C;
  color: #fff;
}
.chart-config__normal {
  background: #F0F0F0;
}
.chart-config__title {
  height: 40px;
  line-height: 40px;
  padding-left: 10px;
}
.chart-config__icon {
  width: 8px;
  height: 16px;
  display: inline-block;
  border-radius: 30%;
  vertical-align: top;
  margin-top: 12px;
}
.chart-config__desc {
  width: 320px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}
.chart-config__desc--dark {
  color: #333;
}
.chart-config__config-btn {
  float: right;
  cursor: pointer;
  width: 34px;
  height: 40px;
  line-height: 40px;
  vertical-align: top;
  text-align: center;
}
.chart-config__config-btn:hover {
  color: #0B8DE5;
}
.chart-config__chart {
  width: 100%;
}
.chart-config__nodata {
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bolder;
  font-size: 16px;
  height: 100%;
  background: #fff;
}
</style>
<template>
  <div :id="'warp-'+chartId" class="chart-config" :style="domStyle">
    <div class="chart-config__title" :class="[chartData.alarm ? 'chart-config__alarm' : 'chart-config__normal']">
      <div class="chart-config__icon" :style="titleIconStyle" v-if="showColorIcon"></div>
      <div class="ilb">
        <div class="chart-config__desc" 
          :class="{'chart-config__desc--dark': darkTheme}"
          :title="title"
          v-text="title"></div>
      </div>
      <div class="chart-config__config-btn" v-show="clickable" @click="e_clickConfig">
        <i class="icon" :class="icon.classname" :title="icon.label"></i>
      </div>
    </div>
    <div class="chart-config__chart" :style="{width: chartWidth, height: chartHeight}">
      <div v-if="noData" class="chart-config__nodata" v-text="$t('common.noData')"></div>
      <chart 
        v-else
        :ref="chartId" 
        :type="type"
        :chart-index="chartIndex" 
        :chart-id="chartId" 
        :chart-data="chartData" 
        :chart-style="chartStyle"
        :dark-theme="darkTheme">
      </chart>
    </div>
  </div>
</template>
<script>
import chart from './chart-base'

const ITEM_COLOR = [
  '#FF0000',
  '#FF8700',
  '#1AAD19',
  '#0B8DE5',
  '#1BCFB3',
  '#6952DF',
  '#DEA409',
  '#9F3BC9',
  '#E34091'
]
const DEFAULT_COLOR = '#919191'

export default {
  data () {
    return {
      titleIconStyle: {
        background: DEFAULT_COLOR
      }
    }
  },
  computed: {
    noData () {
      if (this.chartData && this.chartData.rows && this.chartData.rows.length === 0) {
        return true
      } else {
        return false
      }
    },
    chartHeight () {
      let height = 100
      if (this.domStyle.height) {
        height = this.domStyle.height.substr(0, this.domStyle.height.length - 2)
      } else {
        const wrapDom = document.getElementById('warp-' + this.chartId)
        height = wrapDom.clientHeight
      }
      height = height - 40
      return height + 'px'
    },
    chartWidth () {
      let width = 100
      if (this.domStyle.width) {
        width = this.domStyle.width.substr(0, this.domStyle.width.length - 2)
      } else {
        const wrapDom = document.getElementById('warp-' + this.chartId)
        width = wrapDom.clientWidth
      }
      return width + 'px'
    }
  },
  components: {
    chart
  },
  props: {
    // 继承chart-base的属性
    type: {
      type: String,
      default: 'AREA'
    },
    chartId: {
      type: String,
      require: true
    },
    chartData: {
      type: Object
    },
    chartStyle: {
      type: Object,
      // 自带样式
      default () {
        return {
          grid: {
            left: '4%',
            bottom: '5%',
            top: '14%',
            right: '6%',
            containLabel: true
          },
          toolbox: {
            feature: {
              dataZoom: {
                yAxisIndex: 'none'
              },
              restore: {}
            },
            right: '2%'
          }
        }
      }
    },
    chartIndex: {
      type: Number
    },
    darkTheme: {
      type: Boolean
    },
    // 增加的属性
    title: {
      type: String
    },
    showColorIcon: {
      type: Boolean,
      defualt: true
    },
    clickable: {
      type: Boolean,
      defualt: true
    },
    clickFun: {
      type: Function
    },
    icon: {
      type: Object,
      default () {
        return {
          label: 'icon',
          classname: 'icon-xiugai'
        }
      }
    },
    domStyle: {
      type: Object,
      default () {
        return {
          width: '400px',
          height: '260px'
        }
      }
    }
  },
  watch: {
    noData () {
      this.setStyle(this.chartIndex)
    }
  },
  methods: {
    setStyle (val) {
      this.titleIconStyle = {
        background: this.noData ? DEFAULT_COLOR : ITEM_COLOR[val]
      }
    },
    e_clickConfig () {
      this.clickFun && this.clickFun(this.chartIndex)
    },
    resize () {
      this.$refs[this.chartId].resize()
    }
  },
  mounted () {
    if (this.chartIndex !== undefined) {
      this.setStyle(this.chartIndex)
    }
  }
}
</script>
